module.exports = __webpack_public_path__ + "img/T2C_rc_12.106c27cd.png";